import React, { Component } from 'react'
import PDFreactor from '../../helpers/pdfreactor/PDFreactor'
import ReactDOMServer from 'react-dom/server'
import bookContent from '../../data/jeffSATBookPrintDummyData'
import { Book, BookPrint } from './'


class BookPrintContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      doc: '',
      isGeneratingPdf: false,
      error: '',
    }

  }

  componentDidMount() {
    this.getPdf()
  }

  getPdf() {
    const pdfReactor = new PDFreactor('https://pdf.masteryprep.com:8443/service/rest')


    const doc = ReactDOMServer.renderToStaticMarkup(
      <Book
        bookTitle={bookContent.title}
        bookContent={bookContent}
      />
    )

    const config = {
      addLinks: true,
      javaScriptMode: 'ENABLED_TIME_LAPSE',
      document: doc
    }

    pdfReactor.convert(config, (result) => {
      this.setState({ doc: result.document, isGeneratingPdf: false })
    }, (err) => {
      this.setState({ error: err, isGeneratingPdf: false })
    })
  }

  render() {
    const { doc, error, isGeneratingPdf } = this.state
    return (
      <BookPrint
        doc={doc}
        error={error}
        isGeneratingPdf={isGeneratingPdf}
      />
    )
  }
}

export default BookPrintContainer


// WEBPACK FOOTER //
// ./src/components/BookPrint/BookPrintContainer.js